import React from "react";
import sickle from "../../assets/images/sickle-cell.png";
import sickleMobile from "../../assets/images/sickle-cell-mobile.png";
import healthApp from "../../assets/images/health-app.png";
import "./style.css";
const Disorder = () => {
  return (
    <div className="w-full flex text-text_color lg:justify-between lg:items-stretch justify-center items-center flex-col lg:flex-row lg:mt-44 lg:px-3 mb-20 lg:mb-0 relative z-10">
      <div style={{ width: "100vw" }}>
        <img
          src={sickle}
          alt="sickle-cell"
          className="lg:relative -left-36 bottom-16 hidden lg:hidden xl:block"
        />
        <img
          src={sickleMobile}
          alt="sickle-cell"
          className="lg:hidden mb-5 mx-auto"
        />
      </div>
      <div className="lg:w-3/4">
        <p className="font-Airbnb lg:text-title font-bold text-title_mobile py-2">
          The Sickle Cell Disorder
        </p>
        <div>
          <p
            className="lg:hidden font-Airbnb text-text-mobile lg:text-disorder-text py-3 opacity-70"
            style={{ fontSize: "12px", width: "326px", fontWeight: 300 }}
          >
            Sickle cell disease is a hereditary problem that causes a type of
            faulty hemoglobin in red blood cells. Hemoglobin carries oxygen in
            the blood. Normal red blood cells are disc-shaped and very flexible.
            In sickle cell disease, some red blood cells can change shape so
            that they look like sickles or crescent moons. Because of their
            shape, they don't move well through the smallest blood vessels. This
            can stop or slow blood flow to parts of the body, causing less
            oxygen to reach these areas.
          </p>
          <p
            className="font-Airbnb text-text-mobile lg:text-disorder-text py-3 opacity-70 lg:block hidden"
            style={{ fontWeight: 300, width: "716px" }}
          >
            Sickle cell disease is a hereditary problem that causes a type of
            faulty hemoglobin in red blood cells. Hemoglobin carries oxygen in
            the blood.
          </p>
          <p
            className="font-Airbnb text-text-mobile lg:text-disorder-text opacity-70  lg:block hidden"
            style={{ fontWeight: 300, width: "716px" }}
          >
            Normal red blood cells are disc-shaped and very flexible. In sickle
            cell disease, some red blood cells can change shape so that they
            look like sickles or crescent moons. Because of their shape, they
            don't move well through the smallest blood vessels. This can stop or
            slow blood flow to parts of the body, causing less oxygen to reach
            these areas.
          </p>
        </div>
      </div>

      <div className="w-2/4 hidden lg:hidden xl:block">
        <img src={healthApp} alt="health app" className="ml-auto" />
      </div>
    </div>
  );
};

export default Disorder;
